import { render, staticRenderFns } from "./ManagementSKU.vue?vue&type=template&id=28caeb54&scoped=true"
import script from "./ManagementSKU.vue?vue&type=script&lang=js"
export * from "./ManagementSKU.vue?vue&type=script&lang=js"
import style0 from "./ManagementSKU.vue?vue&type=style&index=0&id=28caeb54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28caeb54",
  null
  
)

export default component.exports